import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      // Helper pour vérifier si le token est expiré
      isTokenExpired: (token) => {
        if (!token) return true
        try {
          const base64Url = token.split('.')[1]
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
          const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          }).join(''))
          
          const { exp } = JSON.parse(jsonPayload)
          if (!exp) return true
          
          // Marge de sécurité de 10 secondes
          return Date.now() >= (exp * 1000) - 10000
        } catch (e) {
          return true
        }
      },

      login: (user, token) => {
        set({ user, token, isAuthenticated: true })
        if (token) localStorage.setItem('auth_token', token)
        if (user) localStorage.setItem('user', JSON.stringify(user))
      },

      setToken: (token) => {
        set({ token, isAuthenticated: !!token })
        if (token) localStorage.setItem('auth_token', token)
        else localStorage.removeItem('auth_token')
      },

      setUser: (user) => {
        set({ user })
        if (user) localStorage.setItem('user', JSON.stringify(user))
        else localStorage.removeItem('user')
      },

      logout: () => {
        set({ user: null, token: null, isAuthenticated: false })
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user')
      },

      // Met à jour les infos d'organisation dans le profil utilisateur
      setOrganization: (organization) => {
        const currentUser = get().user
        if (!currentUser) return
        const updated = { ...currentUser, organization }
        set({ user: updated })
        localStorage.setItem('user', JSON.stringify(updated))
      },

      initFromStorage: () => {
        const token = localStorage.getItem('auth_token')
        
        // Vérification expiration au démarrage
        if (token && get().isTokenExpired(token)) {
          localStorage.removeItem('auth_token')
          localStorage.removeItem('user')
          set({ token: null, user: null, isAuthenticated: false })
          return
        }

        const userStr = localStorage.getItem('user')
        let user = null
        if (userStr) {
          try { user = JSON.parse(userStr) } catch {}
        }
        set({ token, user, isAuthenticated: !!token })
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ user: state.user, token: state.token, isAuthenticated: state.isAuthenticated }),
    }
  )
)
